import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import { CheckModuleAvailabilityForShiftsDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useQuery } from 'modules/core/hooks/useQuery'

import NewThemeHeaderViewNavigator from 'modules/shift_management/components/ShiftManagement/Content/NewThemeHeaderViewNavigator'
import { usePermissions } from 'modules/shift_management/hooks/usePermissions'

import CommandsFilterBar from './CommandsFilterBar'
import ShiftActionsBar from './ShiftActionsBar'
import * as styles from './index.vanilla.css'

interface Props {
  hasNoneShiftManagementPlanning?: boolean
}

const TableHeader = ({ hasNoneShiftManagementPlanning = false }: Props) => {
  // TODO: Remove when Factorial One is the default theme
  // We have introduced more changes than the expected one in this first phase (ResponsePage and tabs)
  const [{ canManageShifts }] = usePermissions()

  const { data: timeOffModuleAvailability } = useQuery(CheckModuleAvailabilityForShiftsDocument, {
    variables: {
      moduleId: AvailableModules.timeoff,
    },
  })

  const hasTimeOffModule = !!timeOffModuleAvailability?.companies.moduleAvailability?.available

  const containerRef = React.useRef<HTMLDivElement>(null)

  return (
    <Box background="white" flexDirection="column" className={styles.header} ref={containerRef}>
      <Box flexDirection="row" paddingBottom="s16" paddingTop="s8" paddingX="s24">
        <CommandsFilterBar
          canManageShifts={canManageShifts}
          hasNoneShiftManagementPlanning={hasNoneShiftManagementPlanning}
        />
        <NewThemeHeaderViewNavigator
          hasNoneShiftManagementPlanning={hasNoneShiftManagementPlanning}
        />
        {/* This Box is used to center the NewThemeHeaderViewNavigator when can't manage shifts */}
        {!canManageShifts && <Box></Box>}
        {canManageShifts && (
          <ShiftActionsBar
            hasNoneShiftManagementPlanning={hasNoneShiftManagementPlanning}
            hasTimeOffModule={hasTimeOffModule}
          />
        )}
      </Box>
    </Box>
  )
}

export default observer(TableHeader)
